/**
 * Saying a scan-time estimate: always a range ("25 to 60 minutes"), never one figure, and in hours
 * once minutes stop being readable. The numbers come from backend/src/lib/scan-estimate.js.
 */
export interface ScanEstimate {
    lowSeconds: number | null
    highSeconds: number | null
    confidence: 'good' | 'fair' | 'low' | 'none'
    unknown: number
    concurrency: number
}

type Translate = (key: string, options?: Record<string, unknown>) => string

/** "25 to 60 minutes", "about 12 minutes", "2 to 3.5 hours" - or null when there is no estimate. */
export function estimateRange(estimate: ScanEstimate | null | undefined, t: Translate): string | null {
    if (!estimate || estimate.lowSeconds == null || estimate.highSeconds == null) return null
    // Round outwards: an estimate that is beaten is forgiven, one that is overrun is not.
    const lowMin = Math.max(1, Math.floor(estimate.lowSeconds / 60))
    const highMin = Math.max(lowMin, Math.ceil(estimate.highSeconds / 60))
    if (highMin >= 120) {
        const half = (minutes: number, up: boolean) => (up ? Math.ceil : Math.floor)(minutes / 30) / 2
        const low = Math.max(0.5, half(lowMin, false))
        const high = Math.max(low, half(highMin, true))
        return low === high ? t('scanRequests.aboutHours', { n: high }) : t('scanRequests.hours', { low, high })
    }
    return lowMin === highMin ? t('scanRequests.aboutMinutes', { n: highMin }) : t('scanRequests.minutes', { low: lowMin, high: highMin })
}
